import React from "react";
import Navbar from "../../Navbar/Navbar";
import Bredcom from "../../Bredcom/Bredcom";
import Footer from "../../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function StrategijaRazvoja() {
  const [t, i18n] = useTranslation();
  const lang = (i18n?.language || "me").toLowerCase();
  const isEN = lang.startsWith("en");

  // Preporuka naziva bez razmaka (lakše za deploy i linkovanje).
  const STRATEGY_PDF_URL = "/Prilozi/STRATEGIJA_RAZVOJA_FPEP_BAR_2026-2029.pdf";

  const content = {
    me: {
      breadHome: "Početna",
      breadTitle: "Strategija razvoja",
      title: "Strategija razvoja FPEP Bar 2026–2029",
      lead: "Strategija razvoja definiše razvojne prioritete Fakulteta za period 2026–2029: unapređenje kvaliteta nastave, jačanje naučno-istraživačkog rada, međunarodna saradnja, partnerstvo sa zajednicom i privredom, sistem kvaliteta, digitalna transformacija i finansijska održivost.",
      periodLabel: "Period važenja",
      periodValue: "2026–2029",
      actionsTitle: "Dokument",
      openPdf: "Otvori PDF",
      downloadDocx: "Preuzmi DOCX",
      tocTitle: "Na ovoj stranici",
      sections: {
        intro: "Uvod",
        visionMission: "Vizija i misija",
        directions: "Ključni strateški pravci",
        areas: "Strateška područja",
        kpi: "Praćenje i KPI",
        docs: "Produkcioni dokumenti",
        preview: "Pregled dokumenta (PDF)",
      },
      introP1:
        "Strategija je koncipirana kao praktičan vodič za upravljanje razvojem Fakulteta: jasno postavlja ciljeve, mjere i indikatore uspješnosti, uz mogućnost prilagođavanja promjenama u okruženju i potrebama tržišta rada.",
      introP2:
        "Fokus nije samo na planu aktivnosti, već i na mjerljivim rezultatima: kvalitet iskustva studiranja, istraživački učinak, međunarodna vidljivost, digitalizacija procesa i održiv institucionalni razvoj.",
      visionTitle: "Vizija",
      missionTitle: "Misija",
      // Sažeto (da stranica ne bude “Word copy-paste”), a dokument je uvijek dostupan za full tekst
      visionText:
        "Biti prepoznatljiva i konkurentna visokoobrazovna i naučno-istraživačka institucija u oblastima ekonomije, menadžmenta i prava, integrisana u evropski prostor visokog obrazovanja i istraživanja.",
      missionText:
        "Pružanje visokokvalitetnog obrazovanja i razvoj kompetencija studenata kroz savremene programe, dualno i praktično učenje, uz jačanje istraživanja i integraciju u evropski i međunarodni akademski prostor.",
      directionsLead:
        "U temelju Strategije su četiri strateška pravca koji usmjeravaju ključne promjene i investicije u periodu 2026–2029.",
      directions: [
        {
          title: "Unapređenje kvaliteta nastave i programa",
          text: "Modernizacija kurikuluma, primjena digitalnih tehnologija i usklađivanje sa standardima Evropskog prostora visokog obrazovanja.",
          icon: "fas fa-graduation-cap",
        },
        {
          title: "Podrška naučno-istraživačkom radu i inovacijama",
          text: "Jačanje naučne vidljivosti i doprinos rješavanju konkretnih ekonomskih i pravnih izazova kroz istraživanje, publikacije i projekte.",
          icon: "fas fa-flask",
        },
        {
          title: "Razvoj međunarodne saradnje",
          text: "Širenje partnerstava, mobilnosti i zajedničkih inicijativa kroz Erasmus+ i druge oblike međunarodnog povezivanja.",
          icon: "fas fa-globe-europe",
        },
        {
          title: "Jačanje saradnje sa društvenom zajednicom i privredom",
          text: "Partnerstva za praksu, projekte i transfer znanja – da Fakultet bude aktivan akter lokalnog i regionalnog razvoja.",
          icon: "fas fa-handshake",
        },
      ],
      areasLead:
        "Strateška područja strukturiraju plan rada po cjelinama (nastava, istraživanje, saradnja, kvalitet, finansije), kako bi sprovođenje bilo jasno i mjerljivo.",
      areas: [
        {
          title: "Naučno-istraživački rad",
          points: [
            "Povećanje broja publikacija i istraživačkih aktivnosti",
            "Uključivanje studenata u NIR i projekte",
            "Vidljivost kroz konferencije i umrežavanje",
          ],
          icon: "fas fa-search",
        },
        {
          title: "Saradnja sa društvenom zajednicom i privredom",
          points: [
            "Model studentske prakse i mentorstva",
            "Zajedničke radionice i stručni događaji",
            "Projekti koji rješavaju realne potrebe okruženja",
          ],
          icon: "fas fa-people-arrows",
        },
        {
          title: "Međunarodna saradnja",
          points: [
            "Sporazumi sa institucijama u inostranstvu",
            "Mobilnosti studenata i osoblja",
            "Učešće u međunarodnim projektima",
          ],
          icon: "fas fa-plane-departure",
        },
        {
          title: "Sistem kvaliteta i radna etika",
          points: [
            "Kontinuirano unapređenje kvaliteta procesa",
            "Transparentnost i evaluacija nastave",
            "Kultura integriteta i odgovornosti",
          ],
          icon: "fas fa-shield-alt",
        },
        {
          title: "Finansijska održivost",
          points: [
            "Planiranje i diverzifikacija prihoda",
            "Ulaganja u infrastrukturu i resurse",
            "Efikasnost i racionalizacija procesa",
          ],
          icon: "fas fa-chart-line",
        },
      ],
      kpiLead:
        "Praćenje realizacije Strategije zasniva se na mjerljivim indikatorima (KPI) koji omogućavaju korektivne mjere i transparentno izvještavanje.",
      kpis: [
        {
          label: "Digitalizovani nastavni i administrativni procesi",
          value: "≥ 80% do kraja 2029",
          icon: "fas fa-laptop-code",
        },
        {
          label: "Novi digitalni alati u nastavi",
          value: "min. 2 godišnje",
          icon: "fas fa-tools",
        },
        {
          label: "Ulaganja u infrastrukturu",
          value: "+10% godišnje",
          icon: "fas fa-university",
        },
        {
          label: "Zadovoljstvo studenata uslovima studiranja",
          value: "≥ 85%",
          icon: "fas fa-star",
        },
        {
          label: "Zaposlenje diplomiranih u roku od 12 mjeseci",
          value: "≥ 75%",
          icon: "fas fa-briefcase",
        },
        {
          label: "Rast broja upisanih studenata",
          value: "+5–10% godišnje",
          icon: "fas fa-user-graduate",
        },
      ],
      docsLead:
        "Za operativnu realizaciju Strategije predviđeni su prateći dokumenti koji formalizuju odluke, organizaciju i politiku kvaliteta.",
      prodDocs: [
        "Odluka Upravnog odbora o donošenju Strategije razvoja 2026–2029",
        "Izmjene i dopune Statuta u kontekstu novonastalih promjena",
        "Politika kvaliteta Fakulteta",
        "Pravilnik o unutrašnjoj organizaciji i sistematizaciji radnih mjesta (u skladu sa sistemom kvaliteta)",
      ],
      previewNote:
        "Ako se PDF ne prikazuje (zavisi od browsera), otvori ga preko dugmeta “Otvori PDF”.",
    },

    en: {
      breadHome: "Home",
      breadTitle: "Development Strategy",
      title: "FPEP Bar Development Strategy 2026–2029",
      lead: "The Development Strategy sets the Faculty’s priorities for 2026–2029: improving teaching quality, strengthening research and innovation, expanding international cooperation, building partnerships with the community and industry, quality assurance, digital transformation, and financial sustainability.",
      periodLabel: "Validity period",
      periodValue: "2026–2029",
      actionsTitle: "Document",
      openPdf: "Open PDF",
      downloadDocx: "Download DOCX",
      tocTitle: "On this page",
      sections: {
        intro: "Introduction",
        visionMission: "Vision & Mission",
        directions: "Key strategic directions",
        areas: "Strategic areas",
        kpi: "Monitoring & KPIs",
        docs: "Supporting documents",
        preview: "Document preview (PDF)",
      },
      introP1:
        "The Strategy is designed as a practical governance guide: it defines goals, measures and success indicators, while staying adaptable to changes in the environment and labour-market needs.",
      introP2:
        "The focus is not only on activities, but on measurable outcomes: student experience, research output, international visibility, digitalisation of processes, and sustainable institutional development.",
      visionTitle: "Vision",
      missionTitle: "Mission",
      visionText:
        "To become a recognisable and competitive higher-education and research institution in economics, management and law, integrated into the European Higher Education and Research Area.",
      missionText:
        "To provide high-quality education and develop student competencies through modern programmes, dual and practice-based learning, while strengthening research and integrating into the European and international academic space.",
      directionsLead:
        "The Strategy is built around four directions that drive key changes and investments for 2026–2029.",
      directions: [
        {
          title: "Enhancing teaching quality and programmes",
          text: "Curriculum modernisation, use of digital technologies, and alignment with the European Higher Education Area standards.",
          icon: "fas fa-graduation-cap",
        },
        {
          title: "Supporting research and innovation",
          text: "Increasing scientific visibility and addressing real economic and legal challenges through research, publications and projects.",
          icon: "fas fa-flask",
        },
        {
          title: "Developing international cooperation",
          text: "Expanding partnerships, mobility and joint initiatives through Erasmus+ and other forms of international collaboration.",
          icon: "fas fa-globe-europe",
        },
        {
          title: "Strengthening community and industry cooperation",
          text: "Partnerships for internships, projects and knowledge transfer-positioning the Faculty as an active actor of regional development.",
          icon: "fas fa-handshake",
        },
      ],
      areasLead:
        "Strategic areas structure delivery by domains (teaching, research, cooperation, quality, finance) to keep implementation clear and measurable.",
      areas: [
        {
          title: "Research activities",
          points: [
            "More publications and research initiatives",
            "Student engagement in research and projects",
            "Visibility through conferences and networks",
          ],
          icon: "fas fa-search",
        },
        {
          title: "Community & industry cooperation",
          points: [
            "Internship model and mentoring",
            "Joint workshops and professional events",
            "Projects responding to real local needs",
          ],
          icon: "fas fa-people-arrows",
        },
        {
          title: "International cooperation",
          points: [
            "Agreements with foreign institutions",
            "Student & staff mobility",
            "Participation in international projects",
          ],
          icon: "fas fa-plane-departure",
        },
        {
          title: "Quality assurance & work ethics",
          points: [
            "Continuous process improvement",
            "Transparency and teaching evaluation",
            "Culture of integrity and responsibility",
          ],
          icon: "fas fa-shield-alt",
        },
        {
          title: "Financial sustainability",
          points: [
            "Planning and revenue diversification",
            "Investments in infrastructure and resources",
            "Efficiency and process optimisation",
          ],
          icon: "fas fa-chart-line",
        },
      ],
      kpiLead:
        "Implementation is monitored through measurable KPIs, enabling corrective actions and transparent reporting.",
      kpis: [
        {
          label: "Digitalised teaching & administrative processes",
          value: "≥ 80% by end of 2029",
          icon: "fas fa-laptop-code",
        },
        {
          label: "New digital tools introduced in teaching",
          value: "min. 2 per year",
          icon: "fas fa-tools",
        },
        {
          label: "Infrastructure investments",
          value: "+10% per year",
          icon: "fas fa-university",
        },
        {
          label: "Student satisfaction with study conditions",
          value: "≥ 85%",
          icon: "fas fa-star",
        },
        {
          label: "Graduate employment within 12 months",
          value: "≥ 75%",
          icon: "fas fa-briefcase",
        },
        {
          label: "Increase in enrolled students",
          value: "+5–10% annually",
          icon: "fas fa-user-graduate",
        },
      ],
      docsLead:
        "Operational delivery is supported by accompanying documents that formalise decisions, organisation and quality policy.",
      prodDocs: [
        "Board decision adopting the 2026–2029 Development Strategy",
        "Statute amendments reflecting new changes",
        "Faculty quality policy",
        "Internal organisation & job systematisation rulebook (aligned with the quality system)",
      ],
      previewNote:
        "If the PDF preview doesn’t load (browser dependent), open it via “Open PDF”.",
    },
  };

  const c = isEN ? content.en : content.me;

  return (
    <>
      <Navbar />
      <Bredcom title={c.breadHome} subtitle={c.breadTitle} />

      <div className="container mt-4 pt-40 strategy-page">
        <div className="row">
          {/* MAIN */}
          <div className="col-md-8">
            <div className="content-container">
              {/* HERO */}
              <header className="ofpep-section strategy-hero">
                <div className="strategy-hero-top">
                  <h1 className="strategy-title">{c.title}</h1>

                  <div className="strategy-meta">
                    <span className="strategy-badge">
                      <i className="far fa-calendar-alt" aria-hidden="true" />{" "}
                      {c.periodLabel}: <strong>{c.periodValue}</strong>
                    </span>
                  </div>

                  <p className="strategy-lead">{c.lead}</p>

                  <div className="strategy-actions" aria-label={c.actionsTitle}>
                    <a
                      className="btn strategy-btn"
                      href={STRATEGY_PDF_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="fas fa-file-pdf"
                        aria-hidden="true"
                        style={{ marginRight: 8 }}
                      />
                      {c.openPdf}
                    </a>
                  </div>
                </div>
              </header>

              {/* TOC */}
              <nav
                className="ofpep-section strategy-toc"
                aria-label={c.tocTitle}
              >
                <h2 className="section-title">{c.tocTitle}</h2>
                <ul>
                  <li>
                    <a href="#uvod">{c.sections.intro}</a>
                  </li>
                  <li>
                    <a href="#vizija-misija">{c.sections.visionMission}</a>
                  </li>
                  <li>
                    <a href="#pravci">{c.sections.directions}</a>
                  </li>
                  <li>
                    <a href="#podrucja">{c.sections.areas}</a>
                  </li>
                  <li>
                    <a href="#kpi">{c.sections.kpi}</a>
                  </li>
                  <li>
                    <a href="#dokumenti">{c.sections.docs}</a>
                  </li>
                  <li>
                    <a href="#pregled">{c.sections.preview}</a>
                  </li>
                </ul>
              </nav>

              {/* INTRO */}
              <section id="uvod" className="ofpep-section strategy-section">
                <h2 className="section-title">{c.sections.intro}</h2>
                <div className="textjustify">
                  <p>{c.introP1}</p>
                  <p>{c.introP2}</p>
                </div>
              </section>

              {/* VISION/MISSION */}
              <section
                id="vizija-misija"
                className="ofpep-section strategy-section"
              >
                <h2 className="section-title">{c.sections.visionMission}</h2>

                <div className="strategy-quote-grid">
                  <div className="strategy-quote">
                    <div className="strategy-quote-head">
                      <i className="fas fa-bullseye" aria-hidden="true" />
                      <h3>{c.visionTitle}</h3>
                    </div>
                    <p>{c.visionText}</p>
                  </div>

                  <div className="strategy-quote">
                    <div className="strategy-quote-head">
                      <i className="fas fa-compass" aria-hidden="true" />
                      <h3>{c.missionTitle}</h3>
                    </div>
                    <p>{c.missionText}</p>
                  </div>
                </div>
              </section>

              {/* DIRECTIONS */}
              <section id="pravci" className="ofpep-section strategy-section">
                <h2 className="section-title">{c.sections.directions}</h2>
                <p className="strategy-muted">{c.directionsLead}</p>

                <div className="strategy-cards">
                  {c.directions.map((item, idx) => (
                    <article className="strategy-card" key={`dir-${idx}`}>
                      <div className="strategy-card-icon" aria-hidden="true">
                        <i className={item.icon} />
                      </div>
                      <h3 className="strategy-card-title">{item.title}</h3>
                      <p className="strategy-card-text">{item.text}</p>
                    </article>
                  ))}
                </div>
              </section>

              {/* AREAS */}
              <section id="podrucja" className="ofpep-section strategy-section">
                <h2 className="section-title">{c.sections.areas}</h2>
                <p className="strategy-muted">{c.areasLead}</p>

                <div className="strategy-areas">
                  {c.areas.map((area, idx) => (
                    <article className="strategy-area" key={`area-${idx}`}>
                      <div className="strategy-area-head">
                        <div className="strategy-area-icon" aria-hidden="true">
                          <i className={area.icon} />
                        </div>
                        <h3 className="strategy-area-title">{area.title}</h3>
                      </div>

                      <ul className="strategy-list">
                        {area.points.map((p, pIdx) => (
                          <li key={`area-${idx}-p-${pIdx}`}>{p}</li>
                        ))}
                      </ul>
                    </article>
                  ))}
                </div>
              </section>

              {/* KPI */}
              <section id="kpi" className="ofpep-section strategy-section">
                <h2 className="section-title">{c.sections.kpi}</h2>
                <p className="strategy-muted">{c.kpiLead}</p>

                <div className="strategy-kpi-grid">
                  {c.kpis.map((k, idx) => (
                    <div className="strategy-kpi" key={`kpi-${idx}`}>
                      <div className="strategy-kpi-icon" aria-hidden="true">
                        <i className={k.icon} />
                      </div>
                      <div className="strategy-kpi-body">
                        <div className="strategy-kpi-label">{k.label}</div>
                        <div className="strategy-kpi-value">{k.value}</div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="strategy-callout">
                  <i className="fas fa-info-circle" aria-hidden="true" />
                  <div>
                    <strong>{isEN ? "Note:" : "Napomena:"}</strong>{" "}
                    {isEN
                      ? "KPIs are used for transparent tracking and corrective actions during implementation."
                      : "KPI služe za transparentno praćenje i korektivne mjere tokom implementacije."}
                  </div>
                </div>
              </section>

              {/* PRODUCTION DOCS */}
              <section
                id="dokumenti"
                className="ofpep-section strategy-section"
              >
                <h2 className="section-title">{c.sections.docs}</h2>
                <p className="strategy-muted">{c.docsLead}</p>

                <ul className="strategy-list">
                  {c.prodDocs.map((d, idx) => (
                    <li key={`doc-${idx}`}>{d}</li>
                  ))}
                </ul>

                <div className="strategy-linkrow">
                  <Link to="/kontakt" className="strategy-link">
                    {isEN ? "Contact" : "Kontakt"}{" "}
                    <i className="fas fa-long-arrow-alt-right" />
                  </Link>
                  <Link to="/o-fpep" className="strategy-link">
                    {t("about.fpep")}{" "}
                    <i className="fas fa-long-arrow-alt-right" />
                  </Link>
                </div>
              </section>

              {/* PDF PREVIEW */}
              <section id="pregled" className="ofpep-section strategy-section">
                <h2 className="section-title">{c.sections.preview}</h2>
                <p className="strategy-muted">{c.previewNote}</p>

                <div className="strategy-pdf-wrap">
                  <iframe
                    className="strategy-pdf"
                    src={STRATEGY_PDF_URL}
                    title={c.title}
                    loading="lazy"
                  />
                </div>
              </section>
            </div>
          </div>

          {/* SIDEBAR (identično kao Erasmus.js) */}
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">{t("sidebar.follow")}</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="YouTube"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>

              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">{t("sidebar.useful")}</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">{t("about.fpep")}</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">
                      {t("admission.Akreditacija")}
                    </Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">{t("upis.title")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">{t("admission.Skolarina")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">{t("saradnja.projekti")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">{t("navbar.Gallery")}</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">{t("navbar.News")}</Link>
                  </li>
                </ul>
              </section>

              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">{t("sidebar.study")}</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.osnovne")}</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      {t("osnovne.rfb")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      {t("osnovne.menadzment")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      {t("osnovne.pravo")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>{t("programs.master")}</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      {t("master.poslovnaEkonomija")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      {t("master.ekonomijaJavnogSektora")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      {t("master.pravo")}
                      <br />
                    </Link>
                  </li>

                  <li>
                    <span className="post-date">
                      <strong>{t("programs.specijalisticke")}</strong> <br />
                    </span>
                    <Link to="/menadzment-javnog-sektora-specijalisticke">
                      {t("specijalisticke.mjs")}
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment-profitnog-sektora-specijalisticke">
                      {t("specijalisticke.mps")}
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default StrategijaRazvoja;
